// Centralized, typed access to environment flags and variables

export type NodeEnvironment = 'development' | 'production' | 'test';

export const NODE_ENV: NodeEnvironment = (process.env.NODE_ENV ||
  'development') as NodeEnvironment;

export const isDev = NODE_ENV === 'development';
export const isProd = NODE_ENV === 'production';
export const isTest = NODE_ENV === 'test';

// Match the existing behavior: enable logging only in development
export const logging = isDev;

// Global API configuration - can be overridden by environment variables
// export const API_BASE_URL = 'http://localhost:4000';
export const API_BASE_URL = 'https://api.clearscan.ca';
// export const API_BASE_URL = 'https://staging.clearscan.ca';
// Log the API URL in development
if (isDev) {
  console.log('🌐 API_BASE_URL:', API_BASE_URL);
}

// Typed helpers for reading environment variables safely
export function getEnv(name: string, defaultValue?: string): string {
  const value = process.env[name] as string | undefined;
  if (value === undefined) {
    if (defaultValue !== undefined) return defaultValue;
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export function getBool(name: string, defaultValue = false): boolean {
  const value = process.env[name] as string | undefined;
  if (value === undefined) return defaultValue;
  return ['1', 'true', 'yes', 'on'].includes(value.toLowerCase());
}

export function getInt(name: string, defaultValue?: number): number {
  const value = process.env[name] as string | undefined;
  if (value === undefined) {
    if (defaultValue !== undefined) return defaultValue;
    throw new Error(`Missing required environment variable: ${name}`);
  }
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed)) {
    throw new Error(
      `Invalid integer for environment variable ${name}: ${value}`
    );
  }
  return parsed;
}
